/**
 * Route for `cpa-safeguard-attribution-fraud-protection`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CpaSafeguardAttributionFraudProtectionPage } from "../features/cpa-safeguard-attribution-fraud-protection/CpaSafeguardAttributionFraudProtectionPage";

export const cpaSafeguardAttributionFraudProtectionRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/cpa-safeguard-attribution-fraud-protection",
	component: CpaSafeguardAttributionFraudProtectionPage,
});

export default cpaSafeguardAttributionFraudProtectionRoute;
